import type { PromptsEmptyStateProps } from "../types";

import React from "react";
import { useTranslation } from "react-i18next";

export const PromptsEmptyState: React.FC<PromptsEmptyStateProps> = ({
  isLoading,
  hasSearchQuery,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="text-center py-8" data-id="prompts-loading">
        {t("Loading...")}
      </div>
    );
  }

  return (
    <div className="text-center py-8" data-id="prompts-empty">
      {hasSearchQuery ? t("No results found") : t("No prompts available")}
    </div>
  );
};
